import { render } from "./AddVolunteer.vue?vue&type=template&id=141d0a71&scoped=true"
import script from "./AddVolunteer.vue?vue&type=script&lang=js"
export * from "./AddVolunteer.vue?vue&type=script&lang=js"

import "./AddVolunteer.vue?vue&type=style&index=0&id=141d0a71&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141d0a71"]])

export default __exports__